<template>
  <li
    :class="{ 'is-selected': selected === value }"
    v-bind="$attrs"
    v-on="$listeners"
    @click="$emit('input', value)"
  >
    <slot>{{ label || value }}</slot>
  </li>
</template>

<script>
export default {
  name: 'TkRadio',
  model: {
    prop: 'selected',
    event: 'input',
  },
  props: {
    value: {
      type: [String, Number],
      required: true,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    selected: {
      type: [String, Number],
      default: '',
    },
  },
}
</script>
